const BudgetModuleListCard = ({ title, isSelected, onClick }) => {
  return (
    <div
      className="list-card"
      onClick={onClick}
      style={{
        borderWidth: 2,
        borderColor: isSelected ? "#0067D5" : undefined,
        background: isSelected ? "#0067D5" : undefined,
        color: isSelected ? "white" : undefined,
      }}
    >
      <p
        className="list-cardText"
        style={{ fontWeight: isSelected ? "bold" : undefined }}
      >
        {title}
      </p>
    </div>
  );
};

export default BudgetModuleListCard;
